var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.action-link[_v-2f13f7b4] {\n    cursor: pointer;\n}\n\n.m-b-none[_v-2f13f7b4] {\n    margin-bottom: 0;\n}\n\n.word-wrap[_v-2f13f7b4] {\n    word-wrap: break-word;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    /*
     * The component's data.
     */
    data: function data() {
        return {
            accessToken: null,

            tokens: [],
            scopes: [],

            form: {
                name: '',
                scopes: [],
                errors: []
            }
        };
    },


    /**
     * Prepare the component.
     */
    ready: function ready() {
        this.getTokens();
        this.getScopes();

        $('#modal-create-token').on('shown.bs.modal', function () {
            $('#create-token-name').focus();
        });
    },


    methods: {
        /**
         * Get all of the personal access tokens for the user.
         */
        getTokens: function getTokens() {
            var _this = this;

            this.$http.get('/oauth/personal-access-tokens').then(function (response) {
                _this.tokens = response.data;

                // If one of the tokens contain the import naming scheme
                // knock it out. We don't want to show it to users. Also
                // hoping that User NEVER names the import naming scheme 
                // for their bearer token :D.
                var tempTokens = _this.tokens.filter(function (token) {
                    return token.name.indexOf("Import FID") == -1;
                });

                _this.tokens = tempTokens;
            });
        },


        /**
         * Get all of the available scopes.
         */
        getScopes: function getScopes() {
            var _this2 = this;

            this.$http.get('/oauth/scopes').then(function (response) {
                _this2.scopes = response.data;
            });
        },


        /**
         * Show the form for creating new tokens.
         */
        showCreateTokenForm: function showCreateTokenForm() {
            $('#modal-create-token').modal('show');
        },


        /**
         * Create a new personal access token.
         */
        store: function store() {
            var _this3 = this;

            this.accessToken = null;

            this.form.errors = [];

            this.$http.post('/oauth/personal-access-tokens', this.form).then(function (response) {
                _this3.form.name = '';
                _this3.form.scopes = [];
                _this3.form.errors = [];

                _this3.tokens.push(response.data.token);

                _this3.showAccessToken(response.data.accessToken);
            }).catch(function (response) {
                if ((0, _typeof3.default)(response.data) === 'object') {
                    _this3.form.errors = _.flatten(_.toArray(response.data));
                } else {
                    _this3.form.errors = ['Something went wrong. Please try again.'];
                }
            });
        },


        /**
         * Toggle the given scope in the list of assigned scopes.
         */
        toggleScope: function toggleScope(scope) {
            if (this.scopeIsAssigned(scope)) {
                this.form.scopes = _.reject(this.form.scopes, function (s) {
                    return s == scope;
                });
            } else {
                this.form.scopes.push(scope);
            }
        },


        /**
         * Determine if the given scope has been assigned to the token.
         */
        scopeIsAssigned: function scopeIsAssigned(scope) {
            return _.indexOf(this.form.scopes, scope) > 0;
        },


        /**
         * Show the given access token to the user.
         */
        showAccessToken: function showAccessToken(accessToken) {
            $('#modal-create-token').modal('hide');

            this.accessToken = accessToken;

            $('#modal-access-token').modal('show');
        },


        /**
         * Revoke the given token.
         */
        revoke: function revoke(token) {
            var _this4 = this;

            this.$http.delete('/oauth/personal-access-tokens/' + token.id).then(function (response) {
                _this4.getTokens();
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-2f13f7b4=\"\">\n    <div _v-2f13f7b4=\"\">\n        <div class=\"panel panel-default\" _v-2f13f7b4=\"\">\n            <div class=\"panel-heading\" _v-2f13f7b4=\"\">\n                <div style=\"display: flex; justify-content: space-between; align-items: center;\" _v-2f13f7b4=\"\">\n                    <!--DEBUG-->\n                    <span title=\"Your API Token generator\" _v-2f13f7b4=\"\">\n                        Personal Access Tokens\n                    </span>\n\n                    <a class=\"action-link\" @click=\"showCreateTokenForm\" _v-2f13f7b4=\"\">\n                        Create New Token\n                    </a>\n                </div>\n            </div>\n\n            <div class=\"panel-body\" _v-2f13f7b4=\"\">\n                <!-- No Tokens Notice -->\n                <p class=\"m-b-none\" v-if=\"tokens.length === 0\" _v-2f13f7b4=\"\">\n                    You have not created any personal access tokens.\n                </p>\n\n                <!-- Personal Access Tokens -->\n                <table class=\"table table-borderless m-b-none\" v-if=\"tokens.length > 0\" _v-2f13f7b4=\"\">\n                    <thead _v-2f13f7b4=\"\">\n                        <tr _v-2f13f7b4=\"\"><th _v-2f13f7b4=\"\">Name</th>\n                        <th _v-2f13f7b4=\"\"></th>\n                    </tr></thead>\n\n                    <tbody _v-2f13f7b4=\"\">\n                        <tr v-for=\"token in tokens\" _v-2f13f7b4=\"\">\n                            <!-- Client Name -->\n                            <td style=\"vertical-align: middle;\" _v-2f13f7b4=\"\">\n                                {{ token.name }}\n                            </td>\n\n                            <!-- Delete Button -->\n                            <td style=\"vertical-align: middle;\" _v-2f13f7b4=\"\">\n                                <a class=\"action-link text-danger\" @click=\"revoke(token)\" _v-2f13f7b4=\"\">\n                                    Delete\n                                </a>\n                            </td>\n                        </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n    <!-- Create Token Modal -->\n    <div class=\"modal fade\" id=\"modal-create-token\" tabindex=\"-1\" role=\"dialog\" _v-2f13f7b4=\"\">\n        <div class=\"modal-dialog\" _v-2f13f7b4=\"\">\n            <div class=\"modal-content\" _v-2f13f7b4=\"\">\n                <div class=\"modal-header\" _v-2f13f7b4=\"\">\n                    <button type=\"button \" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" _v-2f13f7b4=\"\">×</button>\n\n                    <h4 class=\"modal-title\" _v-2f13f7b4=\"\">\n                        Create Token\n                    </h4>\n                </div>\n\n                <div class=\"modal-body\" _v-2f13f7b4=\"\">\n                    <!-- Form Errors -->\n                    <div class=\"alert alert-danger\" v-if=\"form.errors.length > 0\" _v-2f13f7b4=\"\">\n                        <p _v-2f13f7b4=\"\"><strong _v-2f13f7b4=\"\">Whoops!</strong> Something went wrong!</p>\n                        <br _v-2f13f7b4=\"\">\n                        <ul _v-2f13f7b4=\"\">\n                            <li v-for=\"error in form.errors\" _v-2f13f7b4=\"\">\n                                {{ error }}\n                            </li>\n                        </ul>\n                    </div>\n\n                    <!-- Create Token Form -->\n                    <form class=\"form-horizontal\" role=\"form\" @submit.prevent=\"store\" _v-2f13f7b4=\"\">\n                        <!-- Name -->\n                        <div class=\"form-group\" _v-2f13f7b4=\"\">\n                            <label class=\"col-md-4 control-label\" _v-2f13f7b4=\"\">Name</label>\n\n                            <div class=\"col-md-6\" _v-2f13f7b4=\"\">\n                                <input id=\"create-token-name\" type=\"text\" class=\"form-control\" name=\"name\" v-model=\"form.name\" _v-2f13f7b4=\"\">\n                            </div>\n                        </div>\n\n                        <!-- Scopes -->\n                        <div class=\"form-group\" v-if=\"scopes.length > 0\" _v-2f13f7b4=\"\">\n                            <label class=\"col-md-4 control-label\" _v-2f13f7b4=\"\">Scopes</label>\n\n                            <div class=\"col-md-6\" _v-2f13f7b4=\"\">\n                                <div v-for=\"scope in scopes\" _v-2f13f7b4=\"\">\n                                    <div class=\"checkbox\" _v-2f13f7b4=\"\">\n                                        <label _v-2f13f7b4=\"\">\n                                            <input type=\"checkbox\" @click=\"toggleScope(scope.id)\" :checked=\"scopeIsAssigned(scope.id)\" _v-2f13f7b4=\"\">\n\n                                                {{ scope.id }}\n                                        </label>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n\n                <!-- Modal Actions -->\n                <div class=\"modal-footer\" _v-2f13f7b4=\"\">\n                    <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" _v-2f13f7b4=\"\">Close</button>\n\n                    <button type=\"button\" class=\"btn btn-primary\" @click=\"store\" _v-2f13f7b4=\"\">\n                        Create\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <!-- Access Token Modal -->\n    <div class=\"modal fade\" id=\"modal-access-token\" tabindex=\"-1\" role=\"dialog\" _v-2f13f7b4=\"\">\n        <div class=\"modal-dialog\" _v-2f13f7b4=\"\">\n            <div class=\"modal-content\" _v-2f13f7b4=\"\">\n                <div class=\"modal-header\" _v-2f13f7b4=\"\">\n                    <button type=\"button \" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" _v-2f13f7b4=\"\">×</button>\n\n                    <h4 class=\"modal-title\" _v-2f13f7b4=\"\">\n                        Personal Access Token\n                    </h4>\n                </div>\n\n                <div class=\"modal-body\" _v-2f13f7b4=\"\">\n                    <p _v-2f13f7b4=\"\">\n                        Here is your new personal access token. This is the only time it will be shown so don't lose it!\n                        You may now use this token to make API requests.\n                    </p>\n\n                    <pre _v-2f13f7b4=\"\"><code _v-2f13f7b4=\"\">{{ accessToken }}</code></pre>\n                </div>\n\n                <!-- Modal Actions -->\n                <div class=\"modal-footer\" _v-2f13f7b4=\"\">\n                    <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" _v-2f13f7b4=\"\">Close</button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.action-link[_v-2f13f7b4] {\n    cursor: pointer;\n}\n\n.m-b-none[_v-2f13f7b4] {\n    margin-bottom: 0;\n}\n\n.word-wrap[_v-2f13f7b4] {\n    word-wrap: break-word;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2f13f7b4", module.exports)
  } else {
    hotAPI.update("_v-2f13f7b4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}